import type { Utility } from '../../types/utility';
import type { Button } from './button';

const buttonSize: Utility.VariantCSSKeys<Button.Size.VariantKeys> = {
  small: {
    padding: '8px 16px',
  },
  medium: {
    padding: '12px 24px',
  },
  large: {
    padding: '16px 32px',
  },
};

export const buttonSizeVariants = Object.keys(buttonSize) as Button.Size.VariantKeys[];

export default buttonSize;
